<!-- Support card html -->
<!-- Created by: Christian David Sierra Martinez -->
<!-- Improvements/changes:--- -->

<div class="support-card-container" [ngStyle]="{'background-image': 'url(' + supportType.svg +')'}">
    <div class="support-card-content"></div>
</div>
